export default __webpack_public_path__ + "static/media/Chris_Caudill.e0cd0c8c.png";